/* Sport page behaviours. No storage APIs. All motion respects reduced-motion. */
(function(){
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* SEE STUDY → open the matching accordion and scroll to it */
  document.querySelectorAll('[data-open]').forEach(function(a){
    a.addEventListener('click',function(ev){
      var el=document.getElementById(a.getAttribute('data-open'));
      if(!el) return;
      ev.preventDefault();
      el.open=true;
      el.scrollIntoView({behavior:reduce?'auto':'smooth',block:'start'});
    });
  });

  /* Training Days: white logomark parallax ghost */
  [document.getElementById('trainGhost'),document.getElementById('sciGhost')].forEach(function(gh){
  if(gh && !reduce){
    var gRaf=0;
    function gFrame(){ gRaf=0; var r=gh.parentElement.getBoundingClientRect(), vh=window.innerHeight||1;
      var p=(r.top+r.height/2)/vh-0.5; gh.style.transform='translateY('+(p*-90).toFixed(1)+'px)'; }
    function gScroll(){ if(!gRaf) gRaf=requestAnimationFrame(gFrame); }
    window.addEventListener('scroll',gScroll,{passive:true}); window.addEventListener('resize',gScroll); gFrame();
  }
  });

})();
